package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.repository.GameTableRepository

class SaveTableMemberNotesUseCase(private val repository: GameTableRepository) {
    suspend operator fun invoke(tableId: String, userId: String, notes: String): Result<Unit> =
        repository.updateMemberNotes(tableId, userId, notes)
}
